import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import './main-nav-item.js';
import './mega-menu-panel.js';
import '../mega-menu-mobile/index.js';
import css_248z from './mega-menu.scss.js';

// @ts-ignore
class MegaMenu extends s {
    constructor() {
        super(...arguments);
        this.query = '(max-width: 1023px)';
        this.mediumQuery = '(min-width: 1024px) and (max-width: 1919px)';
        this.largeQuery = '(min-width: 1920px)';
        this.rtl = false;
        this.rootUrl = '';
        this.logo = { smallLogo: '', largeLogo: '', midLogo: '' };
        this.data = [];
        this.siteName = '';
        this.activeItemData = { items: [], link: '', title: '' };
        this.panelOpen = false;
        this.activePanel = '';
        this.isMobile = false;
        this.screenSize = 'large';
        this.mobileMenuOpen = false;
        this.backText = 'Go back';
        this.goToButtonText = 'Go to:';
        this.megaMenuPanelOpen = 'mega-menu-panel.open';
        this.panelClose = 'panel-close';
        this.isTouchDevice = false;
        this._onToggle = (e) => this.handleToggle(e);
        this._onPanelClose = (e) => this.handlePanelClose(e);
        this._onMobileClose = () => this.closeMobileMenu();
        this._onDesktopQueryChange = (e) => {
            this.isMobile = !e.matches;
            if (!this.isMobile) {
                this.mobileMenuOpen = false;
            }
        };
        this._onMediumQueryChange = (e) => {
            if (e.matches) {
                this.screenSize = 'medium';
            }
        };
        this._onLargeQueryChange = (e) => {
            if (e.matches) {
                this.screenSize = 'large';
            }
        };
        this._onModalOpened = (e) => {
            var _a;
            const customEvent = e;
            if (((_a = customEvent.detail) === null || _a === void 0 ? void 0 : _a.popupId) === 'search-modal') {
                // Focus the search input when search modal opens
                requestAnimationFrame(() => {
                    const searchModal = document.querySelector('cvt-modal-updated[popupId="search-modal"]');
                    if (searchModal) {
                        const searchForm = searchModal.querySelector('navbar-search-form');
                        if (searchForm &&
                            typeof searchForm.focusInput === 'function') {
                            searchForm.focusInput();
                            searchForm.clearInput();
                        }
                    }
                });
            }
        };
        this.handleLastElementTab = (e) => {
            if (e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault();
                this.handlePanelClose(new CustomEvent(this.panelClose, {
                    detail: { moveFocusNext: false },
                }));
            }
        };
        this.handleFirstElementShiftTab = (e) => {
            if (e.key === 'Tab' && e.shiftKey) {
                e.preventDefault();
                this.handlePanelClose(new CustomEvent(this.panelClose, {
                    detail: { moveFocusNext: false },
                }));
            }
        };
    }
    getLogoSrc() {
        if (this.isMobile) {
            return this.logo.smallLogo;
        }
        if (this.screenSize === 'medium') {
            return this.logo.midLogo;
        }
        return this.logo.largeLogo;
    }
    toggleMobileMenu() {
        this.mobileMenuOpen = !this.mobileMenuOpen;
    }
    closeMobileMenu() {
        this.mobileMenuOpen = false;
    }
    renderMainNavLinks() {
        return this.data.map(branch => $ `<li role="none" @mouseleave="${this._scheduleHide}" @mouseenter="${this._cancelHide}"><main-nav-item role="menuitem" .link="${branch.link}" .title="${branch.title}" .panelId="${branch.title}" .hasItems="${branch.items.length > 0}" .isActive="${this.activePanel === branch.title}"></main-nav-item></li>`);
    }
    renderMobileRight() {
        if (this.mobileMenuOpen) {
            return $ `<generic-button-updated type="primary" appearance="icon-square" icon="close" color="burgundy" @click="${() => this.closeMobileMenu()}"></generic-button-updated>`;
        }
        return $ `<generic-button-updated type="primary" popupId="search-modal" appearance="icon-square" icon="search" color="purple"></generic-button-updated>`;
    }
    renderMobilePrimaryNav() {
        const expanded = this.mobileMenuOpen ? 'true' : 'false';
        const mobileLeft = this.mobileMenuOpen
            ? ''
            : $ `<div class="mobile-left"><button class="hamburger" aria-label="Open menu" aria-expanded="${expanded}" @click="${() => this.toggleMobileMenu()}"><span class="hamburger-icon" aria-hidden="true"></span></button></div>`;
        return $ `<nav id="main-nav" aria-label="Main navigation" class="main-nav" @nav-hover="${this._onNavHover}"><header class="${o({
            'mobile-header': true,
            'no-left': this.mobileMenuOpen,
        })}">${mobileLeft}<div class="mobile-center"><a href="${this.rootUrl}" aria-label="${this.siteName}" class="icon-link"><img loading="lazy" class="logo" src="${this.logo.smallLogo}" alt="" aria-hidden="true"></a></div><div class="mobile-right">${this.renderMobileRight()}</div></header></nav><div class="${this.mobileMenuOpen ? 'mobile-panel open' : 'mobile-panel'}" role="dialog" aria-hidden="${this.mobileMenuOpen ? 'false' : 'true'}"><mega-menu-mobile .data="${this.data}" .open="${this.mobileMenuOpen}" @close="${this._onMobileClose}" .backText="${this.backText}" .goToButtonText="${this.goToButtonText}"><slot name="global-nav" slot="global-nav"></slot></mega-menu-mobile></div><lit-media-query .query="${this.query}" @changed="${this.handleMediaQuery}"></lit-media-query>`;
    }
    renderPrimaryNav() {
        return $ `<div class="icon-responsive"><a href="${this.rootUrl}" aria-label="${this.siteName}" class="icon-link"><img loading="lazy" class="logo" src="${this.getLogoSrc()}" alt="" aria-hidden="true"></a></div><div class="primary-nav">${this.renderNavigation()}</div><div @mouseenter="${this._cancelHide}">${this.renderNavPanels()}</div><div class="search"><generic-button-updated type="primary" popupId="search-modal" appearance="icon-square" icon="search" color="purple"></generic-button-updated></div>`;
    }
    renderNavigation() {
        return $ `<ul role="menubar" class="${o({
            links: true,
            rtl: this.rtl || isRTL(),
        })}">${this.renderMainNavLinks()}</ul>`;
    }
    _syncBannerHeight(banner) {
        var _a, _b;
        const container = (_a = banner.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.alert-banner__container');
        const height = (_b = container === null || container === void 0 ? void 0 : container.offsetHeight) !== null && _b !== void 0 ? _b : 0;
        this.style.setProperty('--alert-banner-height', `${height}px`);
    }
    async _observeBanner(banner) {
        var _a;
        const { updateComplete } = banner;
        if (updateComplete) {
            await updateComplete;
        }
        const container = (_a = banner.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.alert-banner__container');
        if (!container)
            return;
        this._syncBannerHeight(banner);
        this._bannerResizeObserver = new ResizeObserver(() => {
            this._syncBannerHeight(banner);
        });
        this._bannerResizeObserver.observe(container);
    }
    _attachBannerObserver() {
        const banner = document.querySelector('alert-banner');
        if (banner) {
            this._observeBanner(banner);
            return;
        }
        this._domMutationObserver = new MutationObserver(() => {
            var _a;
            const lazyBanner = document.querySelector('alert-banner');
            if (!lazyBanner)
                return;
            (_a = this._domMutationObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
            this._observeBanner(lazyBanner);
        });
        this._domMutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }
    connectedCallback() {
        super.connectedCallback();
        this.isTouchDevice =
            'ontouchstart' in window || navigator.maxTouchPoints > 0;
        // Set up native media queries
        this.desktopQuery = window.matchMedia('(min-width: 1024px)');
        this.mediumScreenQuery = window.matchMedia('(min-width: 1024px) and (max-width: 1919px)');
        this.largeScreenQuery = window.matchMedia('(min-width: 1920px)');
        // Initialize state based on current matches
        this.isMobile = !this.desktopQuery.matches;
        if (this.largeScreenQuery.matches) {
            this.screenSize = 'large';
        }
        else if (this.mediumScreenQuery.matches) {
            this.screenSize = 'medium';
        }
        // Add listeners
        this.desktopQuery.addEventListener('change', this._onDesktopQueryChange);
        this.mediumScreenQuery.addEventListener('change', this._onMediumQueryChange);
        this.largeScreenQuery.addEventListener('change', this._onLargeQueryChange);
        this.addEventListener('nav-item-toggle', this._onToggle);
        this.addEventListener(this.panelClose, this._onPanelClose);
        // Listen for search modal opening to focus the search input
        document.addEventListener('modal-opened', this._onModalOpened);
        this.navResizeObserver = new ResizeObserver(entries => {
            var _a;
            const height = (_a = entries[0]) === null || _a === void 0 ? void 0 : _a.contentRect.height;
            if (height && height > 0) {
                this.style.setProperty('--mega-menu-nav-height', `${height}px`);
            }
        });
        this._attachBannerObserver();
    }
    firstUpdated() {
        this.observeNav();
    }
    updated(changedProperties) {
        if (changedProperties.has('isMobile')) {
            this.observeNav();
        }
    }
    observeNav() {
        var _a;
        if (!this.navResizeObserver)
            return;
        this.navResizeObserver.disconnect();
        const nav = (_a = this.renderRoot) === null || _a === void 0 ? void 0 : _a.querySelector('nav.main-nav');
        if (nav) {
            this.navResizeObserver.observe(nav);
        }
    }
    disconnectedCallback() {
        var _a, _b, _c, _d, _e, _f, _g;
        super.disconnectedCallback();
        (_a = this.navResizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        this.navResizeObserver = undefined;
        (_b = this._bannerResizeObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
        (_c = this._domMutationObserver) === null || _c === void 0 ? void 0 : _c.disconnect();
        // Clean up media query listeners
        (_d = this.desktopQuery) === null || _d === void 0 ? void 0 : _d.removeEventListener('change', this._onDesktopQueryChange);
        (_e = this.mediumScreenQuery) === null || _e === void 0 ? void 0 : _e.removeEventListener('change', this._onMediumQueryChange);
        (_f = this.largeScreenQuery) === null || _f === void 0 ? void 0 : _f.removeEventListener('change', this._onLargeQueryChange);
        this.removeEventListener('nav-item-toggle', this._onToggle);
        this.removeEventListener(this.panelClose, this._onPanelClose);
        document.removeEventListener('modal-opened', this._onModalOpened);
        const activePanel = (_g = this.renderRoot) === null || _g === void 0 ? void 0 : _g.querySelector(this.megaMenuPanelOpen);
        if (activePanel) {
            const focusableElements = this.getAllFocusableElements(activePanel);
            if (focusableElements.length > 0) {
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];
                firstElement.removeEventListener('keydown', this.handleFirstElementShiftTab);
                lastElement.removeEventListener('keydown', this.handleLastElementTab);
            }
        }
    }
    handlePanelClose(e) {
        var _a, _b;
        const shouldReturnFocus = ((_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.moveFocusNext) === false;
        const currentPanel = this.activePanel;
        this.activePanel = '';
        this.panelOpen = false;
        this.activeItemData = { items: [], link: '', title: '' };
        // Set aria-hidden on closing panel
        const closingPanel = (_b = this.renderRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.mega-menu-panel.open');
        if (closingPanel) {
            closingPanel.setAttribute('aria-hidden', 'true');
        }
        if (shouldReturnFocus && currentPanel) {
            requestAnimationFrame(() => {
                var _a, _b;
                const navItems = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('main-nav-item');
                const navItem = Array.from(navItems || []).find(item => item.getAttribute('panelId') === currentPanel);
                const navButton = (_b = navItem === null || navItem === void 0 ? void 0 : navItem.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('button');
                if (navButton) {
                    navButton.focus();
                }
            });
        }
    }
    getStatusMessage() {
        return this.panelOpen && this.activePanel
            ? `${this.activePanel} menu expanded`
            : '';
    }
    render() {
        if (this.isMobile) {
            return this.renderMobilePrimaryNav();
        }
        return $ `<div class="sr-only" role="status" aria-live="polite" aria-atomic="true">${this.getStatusMessage()}</div><nav id="main-nav" aria-label="Main navigation" class="main-nav" @nav-hover="${this._onNavHover}" @mouseenter="${this._cancelHide}">${this.renderPrimaryNav()}</nav><lit-media-query .query="${this.query}" @changed="${this.handleMediaQuery}"></lit-media-query><lit-media-query .query="${this.mediumQuery}" @changed="${this.handleMediumQuery}"></lit-media-query><lit-media-query .query="${this.largeQuery}" @changed="${this.handleLargeQuery}"></lit-media-query>`;
    }
    _onNavHover(e) {
        if (this.isTouchDevice)
            return;
        const { id, active } = e.detail;
        if (active) {
            // Only update if hovering a different item, or just keep current open
            if (this.activePanel !== e.detail.id) {
                this.activePanel = e.detail.id;
                this.activeItemData = this.data.find(m => m.title === id);
            }
            clearTimeout(this.hideTimeout);
            this.panelOpen = true;
        }
    }
    _scheduleHide() {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = window.setTimeout(() => {
            this.panelOpen = false;
            this.activeItemData = null;
            this.activePanel = '';
        }, 300); // delay (ms)
    }
    _cancelHide() {
        clearTimeout(this.hideTimeout);
    }
    handleMediaQuery(e) {
        this.isMobile = e.detail.value;
        // ensure mobile panel is closed when switching out of mobile
        if (!this.isMobile) {
            this.mobileMenuOpen = false;
        }
    }
    handleMediumQuery(e) {
        if (e.detail.value) {
            this.screenSize = 'medium';
        }
    }
    handleLargeQuery(e) {
        if (e.detail.value) {
            this.screenSize = 'large';
        }
        else if (!this.isMobile) {
            this.screenSize = 'medium';
        }
    }
    setupPanelKeyboardNavigation() {
        var _a;
        const activePanel = (_a = this.renderRoot) === null || _a === void 0 ? void 0 : _a.querySelector(this.megaMenuPanelOpen);
        if (!activePanel)
            return;
        activePanel.removeAttribute('aria-hidden');
        const focusableElements = this.getAllFocusableElements(activePanel);
        if (focusableElements.length === 0)
            return;
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        firstElement.removeEventListener('keydown', this.handleFirstElementShiftTab);
        lastElement.removeEventListener('keydown', this.handleLastElementTab);
        firstElement.addEventListener('keydown', this.handleFirstElementShiftTab);
        lastElement.addEventListener('keydown', this.handleLastElementTab);
    }
    getAllFocusableElements(container) {
        const elements = [];
        const searchInNode = (node) => {
            // First, check for direct focusable elements
            const directFocusable = node.querySelectorAll('a[href], button:not([disabled])');
            directFocusable.forEach(el => {
                if (el instanceof HTMLElement && MegaMenu.isElementFocusable(el)) {
                    elements.push(el);
                }
            });
            // Then check for web components that contain focusable elements
            const webComponents = node.querySelectorAll('nav-link, nav-item, sub-nav-item, generic-button-updated, featured-article, nav-category, nav-item-group');
            webComponents.forEach(component => {
                if (component.renderRoot) {
                    const shadowRoot = component.renderRoot;
                    searchInNode(shadowRoot);
                }
            });
        };
        // Start search from the panel's shadow root (mega-menu-panel has its own shadow DOM)
        const panel = container;
        if (panel.renderRoot) {
            searchInNode(panel.renderRoot);
        }
        return elements;
    }
    focusFirstLinkInActivePanel() {
        var _a;
        const activePanel = (_a = this.renderRoot) === null || _a === void 0 ? void 0 : _a.querySelector(this.megaMenuPanelOpen);
        if (!activePanel)
            return;
        requestAnimationFrame(() => {
            const firstLink = MegaMenu.getButtonElement(activePanel) ||
                MegaMenu.getNavCategoryLinks(activePanel) ||
                MegaMenu.findFirstNavItemLink(activePanel);
            if (firstLink) {
                firstLink.focus({ preventScroll: false });
            }
        });
    }
    static isElementFocusable(el) {
        if (!el || !(el instanceof HTMLElement))
            return false;
        if (el.hasAttribute('disabled'))
            return false;
        if (el.tabIndex >= 0)
            return true;
        if (el.tagName.toLowerCase() === 'a') {
            const href = el.getAttribute('href');
            if (href && href !== '#')
                return true;
        }
        return false;
    }
    static findFirstNavItemLink(activePanel) {
        var _a, _b, _c, _d;
        const navItemGroup = (_a = activePanel.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('nav-item-group');
        if (!navItemGroup)
            return null;
        const itemElements = Array.from((_c = (_b = navItemGroup.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('nav-item, sub-nav-item')) !== null && _c !== void 0 ? _c : []);
        for (const itemEl of itemElements) {
            const selector = itemEl.tagName.toLowerCase() === 'nav-item'
                ? '.nav-link'
                : '.sub-nav-link';
            const rr = itemEl.renderRoot;
            const candidate = (_d = rr === null || rr === void 0 ? void 0 : rr.querySelector(selector)) !== null && _d !== void 0 ? _d : null;
            if (MegaMenu.isElementFocusable(candidate)) {
                return candidate;
            }
        }
        return null;
    }
    static getButtonElement(activePanel) {
        var _a, _b, _c;
        // Get nav-category from the panel
        const navCategory = (_a = activePanel === null || activePanel === void 0 ? void 0 : activePanel.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('nav-category');
        if (navCategory) {
            // Get generic-button-updated from nav-category
            const genericButton = (_b = navCategory.renderRoot) === null || _b === void 0 ? void 0 : _b.querySelector('generic-button-updated');
            if (genericButton) {
                const firstLink = (_c = genericButton.renderRoot) === null || _c === void 0 ? void 0 : _c.querySelectorAll('a')[0];
                if (firstLink) {
                    return firstLink;
                }
            }
            // Focus the nav-item itself since it delegates focus
        }
        return null;
    }
    static getNavCategoryLinks(activePanel) {
        var _a, _b, _c;
        const navCategory = (_a = activePanel === null || activePanel === void 0 ? void 0 : activePanel.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('nav-category');
        if (!navCategory)
            return null;
        const navLinks = (_b = navCategory.renderRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('nav-link');
        if (!navLinks || navLinks.length === 0)
            return null;
        // Get the first nav-link's anchor element
        const firstNavLink = navLinks[0];
        const anchor = (_c = firstNavLink.renderRoot) === null || _c === void 0 ? void 0 : _c.querySelector('a.nav-link');
        if (MegaMenu.isElementFocusable(anchor)) {
            return anchor;
        }
        return null;
    }
    handleToggle(e) {
        var _a;
        const triggeredByKeyboard = !!((_a = e.detail) === null || _a === void 0 ? void 0 : _a.keyboard);
        // update state
        this.activePanel = this.activePanel === e.detail.id ? '' : e.detail.id;
        this.activeItemData = this.data.find(m => m.title === e.detail.id);
        this.panelOpen = true;
        if (triggeredByKeyboard) {
            // allow panel to render, then delegate to helper
            requestAnimationFrame(() => {
                this.focusFirstLinkInActivePanel();
                this.setupPanelKeyboardNavigation();
            });
        }
        else {
            requestAnimationFrame(() => {
                this.setupPanelKeyboardNavigation();
            });
        }
    }
    static getPanelId(title) {
        return `${title}-panel`;
    }
    static getLabelledBy(title) {
        return `${title}-button`;
    }
    renderSinglePanel(item) {
        var _a;
        const isActiveForItem = this.panelOpen &&
            this.activePanel === item.title &&
            ((_a = this.activeItemData.items) === null || _a === void 0 ? void 0 : _a.length) > 0;
        return $ `<mega-menu-panel class="${isActiveForItem ? 'open' : ''}" .data="${item !== null && item !== void 0 ? item : { items: [], link: '', title: '' }}" .panelId="${MegaMenu.getPanelId(item.title)}" .labelledBy="${MegaMenu.getLabelledBy(item.title)}" .open="${isActiveForItem}" ?inert="${!isActiveForItem}" @mouseenter="${this._cancelHide}" @mouseleave="${this._scheduleHide}"></mega-menu-panel>`;
    }
    renderNavPanels() {
        return $ `${this.data.map(i => this.renderSinglePanel(i))}`;
    }
}
MegaMenu.styles = css_248z;
__decorate([
    e({ type: String })
], MegaMenu.prototype, "query", void 0);
__decorate([
    e({ type: String })
], MegaMenu.prototype, "mediumQuery", void 0);
__decorate([
    e({ type: String })
], MegaMenu.prototype, "largeQuery", void 0);
__decorate([
    e({ type: Boolean })
], MegaMenu.prototype, "rtl", void 0);
__decorate([
    e()
], MegaMenu.prototype, "rootUrl", void 0);
__decorate([
    e({ type: Object })
], MegaMenu.prototype, "logo", void 0);
__decorate([
    e({ type: Object })
], MegaMenu.prototype, "data", void 0);
__decorate([
    e()
], MegaMenu.prototype, "siteName", void 0);
__decorate([
    t()
], MegaMenu.prototype, "activeItemData", void 0);
__decorate([
    t()
], MegaMenu.prototype, "panelOpen", void 0);
__decorate([
    t()
], MegaMenu.prototype, "activePanel", void 0);
__decorate([
    t()
], MegaMenu.prototype, "isMobile", void 0);
__decorate([
    t()
], MegaMenu.prototype, "screenSize", void 0);
__decorate([
    t()
], MegaMenu.prototype, "mobileMenuOpen", void 0);
__decorate([
    e()
], MegaMenu.prototype, "backText", void 0);
__decorate([
    e({ type: String })
], MegaMenu.prototype, "goToButtonText", void 0);
customElements.define('mega-menu', MegaMenu);

export { MegaMenu };
